module.exports = __webpack_public_path__ + "img/marquee-yuri.de76099f.webp";